import React from 'react'

class BoxContainer extends React.Component {

  styles = () => {
    const style = { backgroundColor: 'transparent' }
    const { border } = this.props
    if (border) {
      style.borderBottomWidth = 1
      style.borderBottomStyle = 'solid'
    }
    return style
  }

  render() {
    return (
      <div className='box-row' >
        <div className='box-container' style={this.styles()}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default BoxContainer



// WEBPACK FOOTER //
// ./src/components/widgets/BoxContainer.js